const logToConsole = (method: keyof Console, message?: any, ...optionalParams: any[]): void => {
  if (globalThis.window?.console?.[method]) {
    (globalThis.window.console as any)[method](message, ...optionalParams);
  }
};

/**
 * WindowLogger for logging messages to the console in a web browser environment.
 * Use this instead of console.log to avoid logging messages to the server when the SSR bundle is evaluated.
 */
export const windowLogger = {
  log: (message?: any, ...optionalParams: any[]) => logToConsole('log', message, ...optionalParams),
  info: (message?: any, ...optionalParams: any[]) => logToConsole('info', message, ...optionalParams),
  error: (message?: any, ...optionalParams: any[]) => logToConsole('error', message, ...optionalParams),
  warn: (message?: any, ...optionalParams: any[]) => logToConsole('warn', message, ...optionalParams),
  debug: (message?: any, ...optionalParams: any[]) => logToConsole('debug', message, ...optionalParams),
};
